import { motion } from "framer-motion";
import { ASSETS, CLINIC } from "@/lib/assets";

const ease = [0.76, 0, 0.24, 1];

export const Footer = () => {
    return (
        <footer
            className="bg-surya-bg text-surya-ink pt-14 md:pt-20 lg:pt-24 pb-8 md:pb-10 px-5 md:px-8 lg:px-10 relative overflow-hidden"
            data-testid="site-footer"
        >
            <div className="mx-auto max-w-[1600px]">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-10%" }}
                    transition={{ duration: 1.2, ease }}
                    className="border-t border-surya-line pt-8 md:pt-10"
                >
                    <h3 className="font-serif font-light tracking-[-0.04em] leading-[0.85] text-[clamp(3rem,14vw,15rem)] text-surya-ink">
                        Surya{" "}
                        <span className="italic-display text-surya-orange">Dental.</span>
                    </h3>
                </motion.div>

                <div className="mt-10 md:mt-16 grid grid-cols-12 gap-6 md:gap-8 lg:gap-10 border-t border-surya-line pt-8 md:pt-10">
                    <div className="col-span-12 md:col-span-4 flex items-start gap-4">
                        <img
                            src={ASSETS.logo}
                            alt="Surya Dental Care"
                            className="h-14 w-14 md:h-16 md:w-16 object-contain shrink-0"
                        />
                        <div>
                            <div className="font-serif text-base md:text-lg text-surya-ink">
                                {CLINIC.name}
                            </div>
                            <div className="label text-surya-muted mt-2 leading-loose text-[0.65rem] md:text-xs">
                                {CLINIC.doctor} · {CLINIC.creds}
                                <br />
                                {CLINIC.specialty}
                            </div>
                        </div>
                    </div>

                    <div className="col-span-6 md:col-span-3">
                        <div className="label text-surya-muted mb-3">Reach</div>
                        <a
                            href={`tel:${CLINIC.phoneE164}`}
                            data-testid="footer-phone"
                            className="block font-serif text-xl md:text-2xl font-light text-surya-ink hover:text-surya-orange"
                        >
                            {CLINIC.phone}
                        </a>
                        <a
                            href={CLINIC.whatsapp}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp"
                            className="mt-2 inline-block label text-surya-inkSoft hover:text-surya-orange"
                        >
                            WhatsApp →
                        </a>
                    </div>

                    <div className="col-span-6 md:col-span-3">
                        <div className="label text-surya-muted mb-3">Hours</div>
                        <p className="text-xs md:text-sm text-surya-inkSoft leading-relaxed">
                            {CLINIC.hours.weekdays}
                        </p>
                        <p className="text-xs md:text-sm text-surya-orange italic-display mt-1">
                            {CLINIC.hours.sunday}
                        </p>
                    </div>

                    <div className="col-span-12 md:col-span-2">
                        <div className="label text-surya-muted mb-3">Located</div>
                        <p className="font-serif text-base md:text-lg font-light leading-tight text-surya-ink">
                            {CLINIC.address}
                        </p>
                        <p className="text-xs md:text-sm text-surya-muted mt-1">
                            {CLINIC.addressLine2}
                        </p>
                    </div>
                </div>

                <div className="mt-10 md:mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 border-t border-surya-line pt-6">
                    <div className="label text-surya-muted text-[0.6rem] md:text-xs">
                        © {new Date().getFullYear()} — Surya Dental Care. All rights reserved.
                    </div>
                    <div className="label text-surya-muted text-[0.6rem] md:text-xs">
                        Crafted with care ·{" "}
                        <span className="italic-display text-surya-orange">Ranchi</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};
